import { AD_CONFIG_START, AD_CONFIG_DATA, AD_CONFIG_SAVE, AD_CONFIG_END } from '../../slices/type';

interface InitState {
  data: any;
  loading: boolean;
  error: string | null;
}

const initState: InitState = { data: null, loading: false, error: null };

interface Action {
  type: string;
  payload?: any;
  loading?: boolean;
}

const AdConfig_Red = (state = initState, action: Action): InitState => {
  switch (action.type) {
    case AD_CONFIG_START:
      return { ...state, loading: true, error: null };
    case AD_CONFIG_DATA:
    case AD_CONFIG_SAVE:
      return { ...state, data: action.payload, loading: false, error: null };
    case AD_CONFIG_END:
      return { ...state, loading: false, error: action.payload ?? 'Error' };
    default:
      return state;
  }
};

export default AdConfig_Red;
